export enum entityGenderEnum {
  MALE = "MALE",
  FEMALE = "FEMALE",
}

export enum FootballEntity {
  football_club = "Football Club",
  football_Club = "Football Club",
  football_academy = "Football Academy",
  federation_entity = "Football Entity",
  sponsor_brand = "Sponsor Brand",
  professional_training_entity = "Professional Training Entity",
  university = "University",
  school = "School",
  other = "Other",
}

export enum UserSubRole {
  FOOTBALL_REFEREE = "Football Referee",
  FOOTBALL_FAN = "Football Fan",
  SPORTS_COMMENTATOR = "Sports Commentator",
  SPORTS_BROADCASTER = "Sports Broadcaster",
  SPORTS_JOURNALIST = "Sports Journalist",
  FOOTBALL_PERFORMANCE_ANALYST = "Football Performance Analyst",
  FOOTBALL_ANALYST = "Football Analyst",
  TEAM_PHYSICIAN = "Team Physician",
  FITNESS_COACH = "Fitness Coach",
  PHYSIOTHERAPIST = "Physiotherapist",
  NUTRITIONIST = "Nutritionist",
  FOOTBALL_CLUB_GENERAL_MANAGER = "Football Club General Manager",
  FOOTBALL_CLUB_DIRECTOR = "Football Club Director",
  FOOTBALL_CLUB_OWNER = "Football Club Owner",
  FOOTBALL_MANAGER = "Football Manager",
  SPORTS_WRITER = "Sports Writer",
  SPORTS_EVENT_COORDINATOR = "Sports Event Coordinator",
  OTHER = "Other",
  ENTITY_ADMIN = "Entity Admin",
}
export enum entityRoleEnum {
  PLAYER = "Player",
  AGENT = "Agent",
  COACH = "Coach",
  SCOUT = "Scout",
  OTHER = "Other",
}

export enum entityTypeEnum {
  FOOTBALL_CLUB = "football_Club",
  FOOTBALL_ACADEMY = "football_academy",
  FEDERATION_ENTITY = "federation_entity",
  SPONSOR_BRAND = "sponsor_brand",
  PROFESSIONAL_TRAINING_ENTITY = "professional_training_entity",
  UNIVERSITY = "university",
  UNIVERSITY_OR_SCHOOL = "university_or_school",
  OTHER = "other",
}

export enum entityVerificationStatusEnum {
  VERIFIED = "VERIFIED",
  UNVERIFIED = "UNVERIFIED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export enum PlayerPositions {
  goalkeeper = "GOALKEEPER (GK)",
  leftBack = "LEFT BACK (LB)",
  centerBack = "CENTER BACK (CB)",
  sweeper = "SWEEPER (SW)",
  rightBack = "RIGHT BACK (RB)",
  leftMidfielder = "LEFT MIDFIELDER (LMF)",
  centerMidfielder = "CENTER MIDFIELDER (CMF)",
  rightMidfielder = "RIGHT MIDFIELDER (RMF)",
  attackingMidFielder = "ATTACKING MIDFIELDER (AMF)",
  defensiveMidFielder = "DEFENSIVE MIDFIELDER (DMF)",
  leftWinger = "LEFT WINGER (LW)",
  centerForward = "CENTER FORWARD (CF)",
  rightWinger = "RIGHT WINGER (RW)",
  striker = "STRIKER (ST)",
}

export enum PlayerPositionsShortEnum {
  "GOALKEEPER (GK)" = "GK",
  "LEFT BACK (LB)" = "LB",
  "CENTER BACK (CB)" = "CB",
  "SWEEPER (SW)" = "SW",
  "RIGHT BACK (RB)" = "RB",
  "LEFT MIDFIELDER (LMF)" = "LMF",
  "CENTER MIDFIELDER (CMF)" = "CMF",
  "RIGHT MIDFIELDER (RMF)" = "RMF",
  "ATTACKING MIDFIELDER (AMF)" = "AMF",
  "DEFENSIVE MIDFIELDER (DMF)" = "DMF",
  "LEFT WINGER (LW)" = "LW",
  "CENTER FORWARD (CF)" = "CF",
  "RIGHT WINGER (RW)" = "RW",
  "STRIKER (ST)" = "ST",
}

export enum EntityLevelEnum {
  "national" = "National",
  "club" = "Club",
}
